import {
  Box,
  Button,
  Container,
  Divider,
  Drawer,
  Paper,
  Stack,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import { Link } from "./core/tanstack-link";
import { SideNav } from "./side-nav";
import { TopBar } from "./top-bar-app";

export function NotFound() {
  return (
    <Box
      sx={{
        minHeight: "100%",
      }}
    >
      <TopBar />
      <nav>
        <Drawer
          anchor="left"
          variant={"permanent"}
          sx={{
            width: {
              xs: "100%",
              sm: "var(--SideNav-width)",
            },
            "& .MuiDrawer-paper": {
              width: {
                xs: "100%",
                sm: "var(--SideNav-width)",
              },
            },
            "@media print": {
              display: "none",
            },
          }}
        >
          <SideNav onNav={() => null} />
        </Drawer>
      </nav>
      <Box
        sx={{
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          pl: { xs: "0", sm: "var(--SideNav-width)" },
          pt: "64px",
          "@media print": {
            pl: "0",
          },
        }}
      >
        <main>
          <Container maxWidth="lg" sx={{ py: 4 }}>
            <Paper>
              <Typography variant="h4">The page you are looking for does not exist.</Typography>
              <Box>
                <Button onClick={() => window.history.back()}>Go back</Button>
                <Link to="/">Start Over</Link>
              </Box>
            </Paper>
            <Divider sx={{ padding: 5 }} />
            <Stack
              direction="row"
              spacing={2}
              sx={{
                "@media print": { display: "none" },
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MuiLink href="https://trove.works/terms-and-conditions">
                <Typography variant="overline" color="text.secondary">
                  Terms and Conditions
                </Typography>
              </MuiLink>
              <Divider orientation="vertical" flexItem />
              <MuiLink href="https://trove.works/privacy-notice">
                <Typography variant="overline" color="text.secondary">
                  Privacy Policy
                </Typography>
              </MuiLink>
              <Divider orientation="vertical" flexItem />
              <MuiLink href="https://trove.works/support-by-trove/">
                <Typography variant="overline" color="text.secondary">
                  Support
                </Typography>
              </MuiLink>
            </Stack>
          </Container>
        </main>
      </Box>
    </Box>
  );
}
